import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "configurations/redux";
import { PURGE, lOGOUT } from "store/rootReducer";
import { signOut } from "firebase/auth";
import { firebaseAuth } from "configurations/firebase";
import posthog from "posthog-js";
import { selectMyUser } from "store/account/selectors";

export default function useLogout() {
  const dispatch = useDispatch();
  const { user } = useSelector(selectMyUser);

  const logout = useCallback(async () => {
    // Clear the user info tracking flag from localStorage
    if (user?.uid) {
      localStorage.removeItem(`userInfo_set_${user.uid}`);
    }

    dispatch(lOGOUT());
    dispatch(PURGE());

    posthog.reset();

    await signOut(firebaseAuth);
    await persistor.flush();
    await persistor.persist();
  }, [dispatch, user]);

  return logout;
}
